import SwiftFlowErrorsPage from '@/features/swiftFlowErrors/SwiftFlowErrorsPage';

export default function SwiftFlowErrors() {
    return <SwiftFlowErrorsPage />;
}
